import type { News, NewsListResult } from '@features/news/types'
import type { NewsDto, NewsListDto } from '@shared/api/news.dto'

/** Преобразует backend DTO новости в доменную модель. */
export const mapNewsDto = (dto: NewsDto): News => ({
  title: dto.title,
  slug: dto.slug,
  content: dto.content,
  shortText: dto.short_text,
  image: dto.image,
  imageCaption: dto.image_caption,
  date: dto.date,
  seoTitle: dto.seo_title,
  seoDescription: dto.seo_description,
  seoKeywords: dto.seo_keywords,
})

/** Преобразует backend-ответ списка новостей в доменную модель. */
export const mapNewsListDto = (dto: NewsListDto): NewsListResult => ({
  count: dto.count,
  next: dto.next ?? null,
  previous: dto.previous ?? null,
  results: (dto.results ?? []).map(mapNewsDto),
})
